/* @flow */
import * as React from 'react';
import Link from 'components/Link';
import Text from 'components/Text';
import LoadingIndicator from 'components/LoadingIndicator';
import type { Organization } from './types';

import './styles/OrganizationPickerSelectedItem.scss';

type Props = {
  /* The organization to display
   */
  organization: Organization,
  /* Called when the user request to change the selected organization
   */
  onChange: Function,
};

class OrganizationPickerSelectedItem extends React.Component<Props, $FlowFixMeState> {
  render() {
    const { organization } = this.props;
    const address = [organization.city, organization.state].filter(Boolean).join(', ');

    return (
      <div className="OrganizationPickerSelectedItem">
        <div className="OrganizationPickerSelectedItem-info">
          <Text element="div" weight="semibold">
            {organization.name}
          </Text>
          <Text element="div">{address}</Text>
        </div>
        <div>
          <Link onClick={this.props.onChange}>
            <Text>Change</Text>
          </Link>
        </div>
      </div>
    );
  }
}

class OrganizationPickerSelectedLoadingItem extends React.Component<{}> {
  render() {
    return (
      <div className="OrganizationPickerSelectedItem OrganizationPickerSelectedItem--loading">
        <LoadingIndicator />
      </div>
    );
  }
}

export { OrganizationPickerSelectedLoadingItem };
export default OrganizationPickerSelectedItem;
